import React from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import { urlModifier } from 'swag-client-common/libs/url-modifier';
import { HEADER_BRANDS_LINE_SIZE } from 'swag-client-common/constants';
import anim from '../subcategories-links/anim.scss';
import classes from './logo-categories.scss';
function divideLogosOnLines({
  subcat,
  size,
  currentSubcategoryId,
  isCurrentCategoryLogo
}) {
  const logosToShow = subcat.slice(0, 27);
  const activeIndex = currentSubcategoryId ? subcat.findIndex(item => item._id === currentSubcategoryId) : 0;
  const activeLineIndex = Math.floor(activeIndex / size);
  const lines = logosToShow.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / size);
    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = [];
    }
    resultArray[chunkIndex].push(item);
    return resultArray;
  }, []);
  if (isCurrentCategoryLogo && activeLineIndex) {
    const res = [...lines];
    res.splice(activeLineIndex, 1);
    res.unshift(lines[activeLineIndex]);
    return res;
  }
  return lines;
}
const Line = ({
  items,
  onLinkClick,
  currentSubcategoryId,
  currentRoute
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.logosLine)
  }, items === null || items === void 0 ? void 0 : items.map(subcat => {
    const isActive = subcat._id === currentSubcategoryId;
    return /*#__PURE__*/React.createElement(Link, {
      key: subcat._id,
      className: classnames(classes.brandItem, {
        [classes.active]: isActive
      }),
      to: urlModifier(`/${currentRoute}/${subcat.slug}`),
      onClick: () => onLinkClick(isActive)
    }, subcat.logoUrl ? /*#__PURE__*/React.createElement("div", {
      style: {
        maskImage: `url(${subcat.logoUrl})`,
        WebkitMaskImage: `url(${subcat.logoUrl})`
      },
      className: classes.brandLogo
    }) : /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.brandItem)
    }, subcat.name));
  }));
};
export function LogoCategoriesComponent({
  subcategories,
  currentRoute,
  currentMainCategory,
  parentCategory,
  currentSubcategoryId,
  onLinkClick,
  isOneline
}) {
  var _lines$, _lines$$;
  const isCurrentCategoryLogo = currentMainCategory.isLogoCategory;
  const initialLines = divideLogosOnLines({
    subcat: subcategories,
    size: HEADER_BRANDS_LINE_SIZE,
    currentSubcategoryId: null,
    isCurrentCategoryLogo
  });
  const [lines, setLines] = React.useState(initialLines);
  const handleSort = () => {
    const sortedLines = divideLogosOnLines({
      subcat: subcategories,
      size: HEADER_BRANDS_LINE_SIZE,
      currentSubcategoryId: currentSubcategoryId,
      isCurrentCategoryLogo
    });
    setLines(sortedLines);
  };
  React.useEffect(() => {
    if (isOneline) {
      handleSort();
    } else {
      setLines(initialLines);
    }
  }, [isOneline]);
  return /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    timeout: 100,
    classNames: anim,
    mountOnEnter: true,
    unmountOnExit: true,
    in: !!subcategories.length,
    key: lines === null || lines === void 0 ? void 0 : (_lines$ = lines[0]) === null || _lines$ === void 0 ? void 0 : (_lines$$ = _lines$[0]) === null || _lines$$ === void 0 ? void 0 : _lines$$._id
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.logosWrapper
  }, /*#__PURE__*/React.createElement(Link, {
    className: classnames(classes.brandItem, {
      [classes.active]: currentSubcategoryId === null
    }),
    to: urlModifier(`/${currentRoute}/${parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.slug}`),
    onClick: () => onLinkClick(currentSubcategoryId === null)
  }, `All ${parentCategory.name}`), /*#__PURE__*/React.createElement("div", {
    className: classes.linesWrapper
  }, lines.map((line, i) => {
    return /*#__PURE__*/React.createElement(Line, {
      key: i,
      items: line,
      onLinkClick: onLinkClick,
      currentSubcategoryId: currentSubcategoryId,
      currentRoute: currentRoute
    });
  })))));
}